import { render, staticRenderFns } from "./AttachFile.vue?vue&type=template&id=b488f466&scoped=true"
import script from "./AttachFile.vue?vue&type=script&lang=ts"
export * from "./AttachFile.vue?vue&type=script&lang=ts"
import style0 from "./AttachFile.vue?vue&type=style&index=0&id=b488f466&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b488f466",
  null
  
)

export default component.exports